import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  private routerInfo: BehaviorSubject<boolean>;

  constructor() {
    this.routerInfo = new BehaviorSubject<boolean>(false);
   }

   apiURL = "https://cslservices.cslbehring.com/api/validinvisiblecaptcha";
   apiHCPURL ="https://api.iterable.com/api/workflows/triggerWorkflow"   
   apiHCPExpection = "https://cslservices.cslbehring.com/api/triggerExpection";
   apiPharmacodeToken = "https://ext-api.pharmacord.com/gateway/security/v1.0/authenticate";
   apiPharmacodeClientId = "FuWpCVYmYERtEawszDc90PEsWi0GIgZO";
   apiPharmacodeClientSecret = "qv_LX5MFc-dEq56UNhlJwfdV1Jf4RoZnWeqIe_i0xWn3fBQiEz1caySzkzZBd-zy";
   apiPharmacodeAudience = "https://extcaps.pharmacord.com/api/v1";
   apiPharmacodeGrantType = "client_credentials";
   apiPharmacodeRegisterProfile="https://ext-api.pharmacord.com/gateway/api/v1.1/pc/registerProfile";
   iQviaWorkflowID = 483983;
   siteKey= "6LfCwuwpAAAAAG2mur_Kj18MRKuWoLsXhtCb7sGu";
   secretKey= "6LfCwuwpAAAAABHotwVtSVZpw_g2AKH0lz7uaKuJ";
 
  getValue(): Observable<boolean> {
    return this.routerInfo.asObservable();
  }
  setValue(newValue): void {
    this.routerInfo.next(newValue);
  }
}
